const InteractionHints = ({ className }) => (
  <div
    className={className || "absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 sm:gap-3 bg-white/80 backdrop-blur-sm px-2 sm:px-3 py-1.5 rounded-full text-[10px] sm:text-xs text-gray-500 pointer-events-none whitespace-nowrap"}
    data-testid="3d-interaction-hint"
  >
    {/* Rotate 360 */}
    <span className="flex items-center gap-1">
      <svg width="18" height="14" viewBox="0 0 24 18" fill="none" className="flex-shrink-0 sm:w-[22px] sm:h-[16px]">
        <path d="M12 1C6.5 1 2 4.5 2 9c0 2.5 1.2 4.7 3 6.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" fill="none" />
        <path d="M12 1c5.5 0 10 3.5 10 8 0 2.5-1.2 4.7-3 6.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" fill="none" />
        <polygon points="2,11 5.5,15.5 6,11" fill="currentColor" />
        <polygon points="22,11 18.5,15.5 18,11" fill="currentColor" />
        <text x="5.5" y="11.5" fontSize="7" fontWeight="bold" fill="currentColor" fontFamily="sans-serif">360°</text>
      </svg>
      <span className="sm:hidden">Drag to rotate</span>
      <span className="hidden sm:inline">Drag to rotate</span>
    </span>
    <span className="text-gray-300">|</span>
    {/* Pan — 4-way cross arrow */}
    <span className="flex items-center gap-1">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" className="flex-shrink-0 sm:w-[16px] sm:h-[16px]">
        <polygon points="12,1 8,6 10,6 10,10 6,10 6,8 1,12 6,16 6,14 10,14 10,18 8,18 12,23 16,18 14,18 14,14 18,14 18,16 23,12 18,8 18,10 14,10 14,6 16,6" />
      </svg>
      <span className="sm:hidden">Two-finger pan</span>
      <span className="hidden sm:inline">Right click hold to pan</span>
    </span>
    <span className="text-gray-300">|</span>
    {/* Zoom */}
    <span className="flex items-center gap-1">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0 sm:w-[14px] sm:h-[14px]">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <line x1="8" y1="11" x2="14" y2="11" />
        <line x1="11" y1="8" x2="11" y2="14" />
      </svg>
      <span className="sm:hidden">Pinch to zoom</span>
      <span className="hidden sm:inline">Scroll to zoom</span>
    </span>
  </div>
);

export default InteractionHints;
